import ActionTypes from "../constants/ActionTypes";

const initialState = {
  isFetching: false,
  detail: {},
  error: null,
  response: null,
};

const adminEditReducer = (state = initialState, action) => {
    switch (action.type) {

    case ActionTypes.FETCH_ADMIN_DETAIL_REQUEST:
        return {
            ...state,
            isFetching: true,
            error: action.payload,
        };

    case ActionTypes.FETCH_ADMIN_DETAIL_SUCCESS:
        return {
            ...state,
            isFetching: false,
            detail: action.payload,
            error: action.payload,
        };

    case ActionTypes.FETCH_ADMIN_DETAIL_FAILURE:
        return {
            ...state,
            isFetching: false,
            error: action.payload,
        };

    // UPDATE
    case ActionTypes.FETCH_ADMIN_UPDATE_REQUEST:
        return { ...state, isFetching: true, error: null };

    case ActionTypes.FETCH_ADMIN_UPDATE_SUCCESS:
        return { 
            ...state,
            isFetching: false,
            response: action.payload,
        };

    case ActionTypes.FETCH_ADMIN_UPDATE_FAILURE:
        return { 
            ...state,
            isFetching: false,
            error: action.payload 
        };

    // DELETE
    case ActionTypes.FETCH_ADMIN_DELETE_REQUEST:
        return {
            ...state,
            isFetching: true,
            error: null,
        };

    case ActionTypes.FETCH_ADMIN_DELETE_SUCCESS:
        return {
            ...state,
            isFetching: false,
            response: action.payload,
        };

    case ActionTypes.FETCH_ADMIN_DELETE_FAILURE:
        return {
            ...state,
            isFetching: false,
            error: action.payload,
        };

    default:
        return state;
    }
};

export default adminEditReducer;
